import { toHttps } from './utils/serviceUrl';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  'http://testambiente.bn.clarovendamos.com.pe/services';

export const SKU_APP = process.env.REACT_APP_SKU_APP || 'ven-web-app';

export const MAX_ATTEMPTS = parseInt(process.env.REACT_APP_MAX_ATTEMPTS || '4');

export const FAQ_URL =
  process.env.REACT_APP_FAQ_URL ||
  'https://clarovendamos.com.pe/puntoventa/mkt_web_preguntas_frecuentes.html';

export const FAQ_URL_HEIGHT = process.env.REACT_APP_FAQ_URL_HEIGHT || 1450;

export const TC_URL =
  process.env.REACT_APP_TC_URL ||
  'https://clarovendamos.com.pe/puntoventa/mkt_web_terminosCondiciones.html';

export const TC_URL_HEIGHT = process.env.REACT_APP_TC_URL_HEIGHT || 2900;

/**
 * El catálogo de propiedades se descarga siempre de aquí, nunca de la llave
 * `url.service.properties` que él mismo publica. Esa llave se guarda con el
 * resto del estado en el navegador: si la copia guardada apuntaba a una URL que
 * ya no responde, la descarga fallaba, la copia vieja se quedaba y el vendedor
 * no podía entrar hasta borrar los datos del sitio (VWA-43). Es la única URL de
 * servicio que no puede venir de las propiedades, porque es la que las trae.
 */
export const PROPERTIES_URL = toHttps(`${API_BASE_URL}/v5/properties`);

/**
 * Llaves de las propiedades que la aplicación descarga al arrancar. Se declaran
 * aquí para que un cambio de nombre del lado del backend se rastree en un solo
 * lugar, en vez de aparecer como una cadena suelta dentro de un hook.
 *
 * La lista crece conforme cada servicio migra a URL dinámica; hoy 12 de los 14
 * todavía la tienen fija en el código.
 */
export const PROPERTY_KEYS = {
  /**
   * Los dos cambios de contraseña —el obligatorio tras una temporal y el
   * voluntario desde Perfil— van a `POST /auth/recoverPassword` de NestJS y se
   * distinguen por la credencial que presentan. Sustituye a Java
   * `url.service.resetpassword`.
   *
   * Ojo al escribirla: el catálogo publica también
   * `url.service.recoverypassword`, a una letra de distancia, que es el Java
   * que **genera** una temporal —la operación contraria—. Ver
   * docs/reference/mapa-de-endpoints-auth.md.
   */
  CHANGE_PASSWORD: 'url.service.recoverPassword',
  /**
   * `loginV8`, no `loginV7`. Las dos llaves resuelven a `POST /auth/login` de
   * NestJS, pero a **despliegues distintos**: `loginV7` va por un API Gateway
   * de AWS que quedó desactualizado, y `loginV8` al backend vigente del
   * ambiente de pruebas. Se comprobó el 2026-09-18 enviando el mismo cuerpo a
   * los dos: las validaciones de `/auth/register` difieren, y el de AWS ni
   * siquiera publica `/auth/recoverPassword`.
   *
   * Importa para el cambio de contraseña obligatorio: el `passwordChangeToken`
   * que exige `recoverPassword` sólo lo emite el despliegue vigente.
   *
   * Logout sigue en el Java legacy: no existe todavía un cierre de sesión de
   * app/web en NestJS — solo el de consola. El backend lo agregará sobre este
   * mismo `/auth/login` con `action: 2`, como ya funciona en Java; el día que
   * exista, LOGOUT pasa a valer lo mismo que LOGIN y esta separación
   * desaparece.
   */
  LOGIN: 'url.service.loginV8',
  LOGOUT: 'url.service.loginV6',
} as const;
